export const exclamation = () => (
  <path
    d="M12 8v4.667m0 2.666h.007"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
